import { Box, Checkbox, FormControl } from "@primer/react";
import { NumberBox } from "devextreme-react/number-box";

import { Controller, useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import Button from "../../../components/ui/button";
import Modal from "../../../components/ui/modal";
import ModalActions from "../../../components/ui/modal/ModalActions";
import Text from "../../../components/ui/text";
import TextInput from "../../../components/ui/text-input";
import { showNotify } from "../../../helpers/toast";
import { sf_hinhthucmiengiam_group } from "../../../models/response/hinh-thuc-mien-giam/sf_hinhthucmiengiam_group";
import { RootState } from "../../../state/reducers";
type Props = {
  title?: string;
  sf_hinhthucmiengiam_group?: sf_hinhthucmiengiam_group;
  onClose: () => void;
  onSubmit: (data: sf_hinhthucmiengiam_group) => void;
  is_saving?: boolean;
  animationOf: string;
  sf_hinhthucmiengiam_groups?: sf_hinhthucmiengiam_group[];
};
const NhomMienGiamEditModal = (props: Props) => {
  const { dm_coso_id } = useSelector((x: RootState) => x.common);

  // Calculate default thu_tu value
  const getDefaultThuTu = () => {
    if (props.sf_hinhthucmiengiam_group?.thu_tu) {
      return props.sf_hinhthucmiengiam_group.thu_tu;
    }

    if (props.sf_hinhthucmiengiam_groups && props.sf_hinhthucmiengiam_groups.length > 0) {
      const maxThuTu = Math.max(...props.sf_hinhthucmiengiam_groups.map(group => group.thu_tu || 0));
      return maxThuTu + 1;
    }

    return 1;
  };

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    control,
    formState: { errors },
  } = useForm<sf_hinhthucmiengiam_group>({
    defaultValues: {
      ...props.sf_hinhthucmiengiam_group,
      thu_tu: getDefaultThuTu(),
      is_active: props.sf_hinhthucmiengiam_group?.is_active ?? true,
    },
  });
  const onSubmit = async (data: any) => {
    // Check for duplicate ma_nhom_mien_giam
    if (props.sf_hinhthucmiengiam_groups && data.ma_nhom_mien_giam) {
      const existingGroup = props.sf_hinhthucmiengiam_groups.find(
        (group) =>
          group.ma_nhom_mien_giam === data.ma_nhom_mien_giam &&
          group.id !== props.sf_hinhthucmiengiam_group?.id
      );

      if (existingGroup) {
        showNotify({ message: "Mã nhóm miễn giảm đã tồn tại!", type: "error" });

        return;
      }
    }

    props.onSubmit({
      ...data,
      dm_coso_id: dm_coso_id,
    });
  };
  return (
    <Modal
      isOpen
      title={props.sf_hinhthucmiengiam_group ? "Cập nhật" : "Thêm mới"}
      onClose={() => {
        props.onClose();
      }}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <Box sx={{ display: "grid", gap: 2 }}>
          <FormControl>
            <FormControl.Label>
              <Text text="Mã nhóm miễn giảm" />
            </FormControl.Label>
            <TextInput
              block
              name="ma_nhom_mien_giam"
              register={register}
              errors={errors}
              required
              validateMessage={"Vui lòng điền mã nhóm miễn giảm"}
            />
          </FormControl>
          <FormControl>
            <FormControl.Label>
              <Text text="Tên nhóm miễn giảm" />
            </FormControl.Label>
            <TextInput
              block
              name="ten_nhom_mien_giam"
              register={register}
              errors={errors}
              required
              validateMessage={`Vui lòng điền tên nhóm miễn giảm`}
            />
          </FormControl>
          <FormControl>
            <FormControl>
              <FormControl.Label>Thứ tự</FormControl.Label>
              <Controller
                control={control}
                name="thu_tu"
                rules={{
                  required: {
                    value: true,
                    message: "Vui lòng điền thứ tự nhóm miễn giảm",
                  },
                }}
                render={({ field }) => (
                  <NumberBox
                    stylingMode="outlined"
                    onValueChanged={(e) => {
                      field.onChange(e.value);
                    }}
                    min={1}
                    value={field.value}
                  />
                )}
              />
            </FormControl>
          </FormControl>
          <FormControl>
            <FormControl.Label>Áp dụng</FormControl.Label>
            <Checkbox
              checked={watch(
                "is_active",
                props.sf_hinhthucmiengiam_group?.is_active
              )}
              onChange={(e) => {
                setValue("is_active", e.target.checked);
              }}
            />
          </FormControl>
        </Box>

        <ModalActions>
          <Button
            text="Đóng"
            onClick={() => {
              props.onClose();
            }}
          />
          <Button text="Cập nhật" variant="primary" type="submit" />
        </ModalActions>
      </form>
    </Modal>
  );
};

export default NhomMienGiamEditModal;
